import React, { Component } from 'react';
import { Select, Button } from 'antd';

import { SUBJECT_PART, GRADE_PART } from '../../../utils/questionManageType';

const Option = Select.Option;
export default class SubjectSelect extends Component {
    state = {
        preSubject:'',
        preGrade:'',
        curSubject:'0',
        curGrade:'10'
    }

    componentDidMount() {

    }

    subjectChange = curSubject => {
        this.setState({curSubject});
    }

    gradeChange = curGrade => {
        this.setState({curGrade});
    }

    conditionClick = () => {
        const { handleConditionClick } = this.props;
        const { preSubject, preGrade, curSubject, curGrade } = this.state;
        if (preSubject === curSubject && preGrade === curGrade) return;
        this.setState({preSubject: curSubject, preGrade: curGrade});
        handleConditionClick(curGrade, curSubject);
    }


    render() {
        return (
            <div style={{padding:20}}>
                {/*筛选学科，年级*/}
                <div className="subject" style={{display:'inline-block',width:200,marginRight:30}}>
                    <Select defaultValue="0" onChange={ this.subjectChange } style={{width:'100%'}}>
                        {
                            Object.keys(SUBJECT_PART).map((val, k) => 
                            <Option key={k} value={val}>{SUBJECT_PART[val]}</Option>
                            )
                        }
                      </Select>
                </div>
                <div className="grade" style={{display:'inline-block',width:200,marginRight:30}}>
                    
                    <Select defaultValue="10" onChange={ this.gradeChange } style={{width:'100%'}}>
                        {
                            Object.keys(GRADE_PART).map((val, k) => 
                            <Option key={k} value={val}>{GRADE_PART[val]}</Option>
                            )
                        }
                      </Select>
                </div>
                <div className="control_btn" style={{display:'inline-block'}}>
                    <Button onClick={ this.conditionClick }>
                        选择
                    </Button>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/entry_app/question_manage/bulk_Import/SubjectSelect.js